export const useHelpers = () => {
    
    const extractPermissionsSelected = (items, selected = []) => {
        items.forEach((item) => {
            if (item.is_assigned) {
                selected.push(item);
            }
            if (item.hijos && item.hijos.length > 0) {
                extractPermissionsSelected(item.hijos, selected);
            }
        });
        return selected;
    };

    const validatePassword = (password) => {

    const minLength = /.{8,}/
    const upperCase = /[A-Z]/
    const lowerCase = /[a-z]/
    const number = /[0-9]/
    const specialChar = /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/+=;'`~]/
    const noSpaces = /^\S*$/

    if (!minLength.test(password)) {
        return {
            success: false,
            message: 'La contraseña debe tener al menos 8 caracteres'
        }
    }

    if (!upperCase.test(password)) {
        return {
            success: false,
            message: 'La contraseña debe contener al menos una letra mayúscula'
        }
    }

    if (!lowerCase.test(password)) {
        return {
            success: false,
            message: 'La contraseña debe contener al menos una letra minúscula'
        }
    }

    if (!number.test(password)) {
        return {
            success: false,
            message: 'La contraseña debe contener al menos un número'
        }
    }

    if (!specialChar.test(password)) {
        return {
            success: false,
            message: 'La contraseña debe contener al menos un carácter especial'
        }
    }

    if (!noSpaces.test(password)) {
        return {
            success: false,
            message: 'La contraseña no puede contener espacios'
        }
    }

    return {
        success: true,
        message: 'Contraseña válida'
    }
}
    
    return Object.freeze({
        extractPermissionsSelected,
        validatePassword
    })
}